<template>
  <div class="operation-report-edit-button">
    <vs-button
      class="edit-button cursor-pointer"
      :color="AISEA_COLOR.BLUE"
      type="border"
      style="padding: 5px 14px;"
      @click="onClick"
    >
      <div class="flex justify-center items-center col-gap-2">
        <edit-icon />
      </div>
    </vs-button>
  </div>
</template>

<script>
import ColorMixin from "@/mixins/ColorMixin.js";
import EditIcon from "@/views/enterprise/addon/operation/components/icons/EditIcon";
const EVENTS = {
  CLICK: "click",
};

export default {
  name: "OperationReportEditButton",
  mixins: [ColorMixin],
  components: { EditIcon },
  methods: {
    onClick() {
      this.$emit(EVENTS.CLICK);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.operation-report-edit-button {
  ::v-deep .edit-button {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    border: 1px solid $aisea-blue;

    .vs-button-backgroundx.vs-button--background {
      display: none; // ボタンクリックした時に、背景色が変わるのを防ぐ
    }
  }
}
</style>
